import {
  FETCH_ALL_JOBS,
  FETCH_JOB,
  CREATE_JOB,
  UPDATE_JOB,
  DELETE_JOB,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const jobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_JOBS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_JOBS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_JOBS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_JOB}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_JOB}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_JOB}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_JOB}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_JOB}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_JOB}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_JOB}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_JOB}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_JOB}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_JOB}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_JOB}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_JOB}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
